import { render, staticRenderFns } from "./TrangXemGroup.vue?vue&type=template&id=bd447a70&"
import script from "./TrangXemGroup.vue?vue&type=script&lang=js&"
export * from "./TrangXemGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports